export enum CommodityType {
  GOLD = "GOLD",
  SILVER = "SILVER",
  OTHER = "OTHER",
}
